import React from 'react';
import { Fade, useMediaQuery } from '@mui/material';

/**
 * Lightweight chart transition wrapper.
 * - Avoids adding a full animation library in Phase 1.
 * - Respects prefers-reduced-motion.
 */
export default function AnimatedChart({ animationKey, children, timeout = 180 }) {
  const reducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');
  const key = animationKey ?? 'chart';

  if (reducedMotion) return <>{children}</>;

  return (
    <Fade in key={key} timeout={timeout}>
      <div style={{ height: '100%', width: '100%' }}>{children}</div>
    </Fade>
  );
}


